import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenTimeService {
  private processScreenTime = new BehaviorSubject<number>(0);
  private stepScreenTime = new BehaviorSubject<number>(0);

  constructor() {
    timer(1000, 1000).subscribe(() => {
      this.stepScreenTime.next(this.stepScreenTime.value + 1);
      this.processScreenTime.next(this.processScreenTime.value + 1);
    });
  }

  resetScreenTime(): void {
    this.stepScreenTime.next(0);
  }

  getStepScreenTime(): Observable<number> {
    return this.stepScreenTime.asObservable();
  }

  getProcessScreenTime(): Observable<number> {
    return this.stepScreenTime.asObservable();
  }
}
